import { ProductBuilderMachineState } from '../../types';
import { ProductType } from '../productTypes';
import { honeycombStatesByProductType } from './honeycombStates';
import { rollerStatesByProductType } from './rollerStates';
import { shutterStatesByProductType } from './shutterStates';
import { venetianBlindsStatesByProductType } from './venetianBlindsStates';
import { romanStatesByProductType } from './romanStates';
import { curtainStatesByProductType } from './curtainStates';

type StatesByProductType = {
  [key in ProductType]: ProductBuilderMachineState[];
};
export const statesByProductType: StatesByProductType = {
  ...honeycombStatesByProductType,
  ...rollerStatesByProductType,
  ...shutterStatesByProductType,
  ...venetianBlindsStatesByProductType,
  ...romanStatesByProductType,
  ...curtainStatesByProductType,
};
